module.exports = __webpack_public_path__ + "static/img/02_乗務員@2x.1fb222b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02_乗務員@2x.png
// module id = 1FPw
// module chunks = 0